import { render, staticRenderFns } from "./myteamidp.vue?vue&type=template&id=15a3a982"
import script from "./myteamidp.vue?vue&type=script&lang=js"
export * from "./myteamidp.vue?vue&type=script&lang=js"
import style0 from "./myteamidp.vue?vue&type=style&index=0&id=15a3a982&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports